import { AutocompletePlugin } from '@/components/pages/search/SearchBox/SearchBox.types'

export const emptyStatePlugin = (
	shouldShowEmptyState: () => boolean
): AutocompletePlugin<{
	objectID: string
	query: string
	value: string
}> => {
	return {
		name: 'emptyStatePlugin',
		getSources() {
			return [
				{
					sourceId: 'emptyStateSource',
					getItems({ query }) {
						// Only return a result when there's no query to trigger openOnFocus
						if (query && query.length > 0) {
							return []
						}

						// Only show empty state when user has manually focused or interacted
						if (!shouldShowEmptyState()) {
							return []
						}

						// Return a minimal item just to trigger the autocomplete to open
						return [
							{
								objectID: 'empty-state-trigger',
								query: '',
								value: '',
							},
						]
					},
					onSelect() {
						// No action needed
					},
				},
			]
		},
	}
}
